
import React from 'react';

interface BaseLayoutProps {
  children: React.ReactNode;
}

export default function BaseLayout({ children }: BaseLayoutProps) {
  return (
    <div className="min-h-screen relative">
      <div className="retro-grid" />
      {children}
    </div>
  );
}
